import(/* webpackMode: "eager" */ "/tmp/claude-1000/-home-dustinm2-dmayfieldjones-github-io/e06cb73b-835d-4d3a-a729-25cde2da7399/scratchpad/live/app/about/page.tsx");
